import type { InvalidParameter } from 'common/errors'
import { GenericHttpError } from 'common/http/httpError'

/**
 * Returns the API's specific problem detail or a user-facing fallback.
 */
export function formatError(error: unknown, fallback: string): string {
    return httpErrorDetail(error) ?? fallback
}

function httpErrorDetail(error: unknown): string | undefined {
    if (!(error instanceof GenericHttpError)) return undefined
    if (typeof error.body === 'string') return error.body || undefined

    const { detail } = error.body
    if (typeof detail === 'string' && detail) return detail
    if (Array.isArray(detail)) {
        const reasons = detail.filter(isInvalidParameter).map(({ reason }) => reason)
        if (reasons.length > 0) return reasons.join(', ')
    }
    return undefined
}

const isInvalidParameter = (value: unknown): value is InvalidParameter =>
    typeof value === 'object' && value !== null && 'reason' in value && typeof value.reason === 'string'
